import React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import proworklogo from "./proworkLogo.jpeg";
const FooterDiv = styled.div`
    display: flex;
    justify-content: space-between;
`;
export default () => {
    return (
        <FooterDiv>
            <Typography
                style={{ marginTop: 15, marginRight: 10 }}
                variant="subheading"
            >
                Powered By
            </Typography>
            <img
                src={proworklogo}
                style={{ height: 50, borderRadius: 10 }}
                alt="Logo"
            />
        </FooterDiv>
    );
};
